import { LocaleId } from '@domgen/dgx-fe-i18n';
import { TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n/lib/models/translation-dictionary/translation-dictionary-mapping.type';
import { FeatureCheckoutTranslationDictionary } from './feature-checkout-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureCheckoutTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      CHECKOUT_BANNER_TITLE: '{{firstName}}, let’s set up your ',
      CHECKOUT_BANNER_TITLE_BRAND: '{{brandName}} Appliance Care',
    },
    [LocaleId.English_Ireland]: {
      CHECKOUT_BANNER_TITLE: '{{firstName}}, let’s set up your ',
      CHECKOUT_BANNER_TITLE_BRAND: '{{brandName}} Appliance Care',
    },
    [LocaleId.English_US]: {
      CHECKOUT_BANNER_TITLE: '{{firstName}}, let’s set up your ',
      CHECKOUT_BANNER_TITLE_BRAND: '{{brandName}} Appliance Care',
    },
  };
